/**
 * Plain labels for the argument names Benny's write tools take, used by the
 * confirmation card and the plan card when they list what a step will set
 * (Benny UX pass 3). Keys not listed here are humanized from camelCase;
 * keys listed as `null` are never shown to the user.
 */
export const FIELD_LABELS: Record<string, string | null> = {
  name: 'Name',
  title: 'Name',
  subject: 'Name',
  displayName: 'Name',
  description: 'Description',
  contentHtml: 'Content',
  projectId: 'Project',
  parentTaskId: 'Parent task',
  taskId: 'Task',
  taskIds: 'Tasks',
  groupId: 'Group',
  sprintId: 'Sprint',
  assignees: 'Assignees',
  assigneeIds: 'Assignees',
  userIds: 'People',
  userId: 'Person',
  assignedToId: 'Owner',
  memberId: 'Owner',
  dueDate: 'Due',
  scheduledFor: 'Scheduled',
  startDate: 'Start',
  endDate: 'End',
  startTime: 'Start',
  endTime: 'End',
  closeDate: 'Close date',
  expectedCloseDate: 'Close date',
  entryDate: 'Date',
  date: 'Date',
  paidAt: 'Paid on',
  priority: 'Priority',
  status: 'Status',
  statusId: 'Status',
  stage: 'Stage',
  stageTypeId: 'Stage',
  lifecycleStage: 'Stage',
  amount: 'Amount',
  value: 'Amount',
  totalAmount: 'Total',
  currency: 'Currency',
  paymentMethod: 'Payment method',
  entityId: 'Client',
  contactId: 'Contact',
  primaryContactId: 'Primary contact',
  invoiceId: 'Invoice',
  invoiceNumber: 'Invoice',
  dealId: 'Deal',
  ticketId: 'Ticket',
  noteId: 'Note',
  eventId: 'Event',
  documentId: 'Document',
  collectionId: 'Collection',
  recordId: 'Record',
  label: 'Label',
  module: 'Module',
  moduleType: 'Module',
  moduleId: 'Record',
  tags: 'Tags',
  estimatedHours: 'Estimate (h)',
  storyPoints: 'Story points',
  duration: 'Duration',
  durationMinutes: 'Duration (min)',
  billable: 'Billable',
  isPrimary: 'Primary contact',
  isPinned: 'Pinned',
  visibility: 'Visibility',
  email: 'Email',
  phone: 'Phone',
  website: 'Website',
  url: 'URL',
  goal: 'Goal',
  comment: 'Comment',
  reason: 'Reason',
  note: 'Note',
  ids: 'Entries',
  items: 'Items',
  // Never shown: bookkeeping and free-form blobs.
  customFields: null,
  data: null,
  dryRun: null,
  confirm: null,
  userConfirmed: null,
  draftId: null,
  chatTurnId: null,
  code: null,
  slug: null,
  bannerImageKey: null,
}

/** Label for an argument name, humanizing unknown camelCase keys. */
export function fieldLabel(key: string): string | null {
  if (key in FIELD_LABELS) return FIELD_LABELS[key] ?? null
  const spaced = key
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/_/g, ' ')
    .toLowerCase()
  return spaced.charAt(0).toUpperCase() + spaced.slice(1)
}
